import Features from '@Features/feature-flags.js';
import { IUserTenants } from '../users.interface';

const dashboardAppTenants = ((Features as any)?.enableDashboardApps || '').split(',');

type TUserTenantsContext = {
  tenants: IUserTenants[];
  currentTenantName: string;
  showDashboardApps: boolean;
};

/**
 * Returns the current user tenants context used for the MenuItemsBottom & Welcome components.
 * @param tenants
 * @param tenantId
 * @returns TUserTenantsContext
 */
export const setCurrentUserTenantsContext = (
  tenants: IUserTenants[] | null,
  tenantId: string | null
): TUserTenantsContext => {
  const tenantsList = tenants || []; // Ensure tenants is an array. When logging in from the admin-login, tenants are null.
  const currentTenantName =
    tenantId !== null ? tenantsList.find((tenant) => tenant.id === tenantId)?.name || '' : '';

  let showDashboardApps = false;

  for (let i = 0; i < dashboardAppTenants.length; i++) {
    if (dashboardAppTenants[i] === currentTenantName && currentTenantName !== '') {
      showDashboardApps = true;
      break;
    }
  }

  return {
    tenants: tenantsList,
    currentTenantName,
    showDashboardApps,
  };
};
